import Box from "../../components/Box"
import Text from "../../components/Text";

const StoryOfEveryIndianEdu = () => {
    return <Box
        badge={"WHY YOU NEED US"}
        title={"The Story of Every Indian Educator"}
        description={"Once, schools grew on trust. Today, parents decide online. Many great schools remain unseen — not from lack of heart, but lack of time, tools and technology. Corporate chains hire expensive agencies and drown everyone else out. We call this the inequality of attention — where visibility, not value, wins."}
        leftBlock={<aside aria-label="Key features" className="self-center space-y-6 md:space-y-5 sm:space-y-4">
            <section>
                <div className="flex flex-col gap-3 mb-3">
                    <div className="px-2 py-1 rounded-lg bg-[#4949DE1A] w-fit">
                        <svg className="w-6 h-6 text-[#4949DE] flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                    </div>
                    <div>
                        <Text type="cardTitle" cName={"text-lg md:text-base font-semibold"} label={"You Wear Many Hats"} />
                        <Text type="description" cName={"mt-1 text-sm sm:text-xs text-muted-foreground"} label={"Visionary, mentor, nation-builder — but also expected to master websites, SEO and hashtags."} />
                    </div>
                </div>
            </section>

            <section>
                <div className="flex flex-col gap-3 mb-3">
                    <div className="px-2 py-1 rounded-lg bg-[#4949DE1A] w-fit">
                        <svg className="w-6 h-6 text-[#4949DE] flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <div>
                        <Text type="cardTitle" cName={"text-lg md:text-base font-semibold"} label={"No Time For Marketing"} />
                        <Text type="description" cName={"mt-1 text-sm sm:text-xs text-muted-foreground"} label={"Between classes, staff and parents, the internet decides who gets noticed by the masses."} />
                    </div>
                </div>
            </section>

            <section>
                <div className="flex flex-col gap-3 mb-3">
                    <div className="px-2 py-1 rounded-lg bg-[#4949DE1A] w-fit">
                        <svg className="w-6 h-6 text-[#4949DE] flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <div>
                        <Text type="cardTitle" cName={"text-lg md:text-base font-semibold"} label={"We Bridge Vision & Visibility"} />
                        <Text type="description" cName={"mt-1 text-sm sm:text-xs text-muted-foreground"} label={"SooMuch.ai becomes your always-on and visible AI-powered marketing team, aligned with your goals."} />
                    </div>
                </div>
            </section>
        </aside>}
        rightBlock={<div className="flex justify-center">
            <img
                src="/images/new-landing-page/storyOfIndianv2.png"
                alt="storyOfIndianv2"
            />
        </div>}
    />
}

export default StoryOfEveryIndianEdu;